import { CommandBarButton, FontIcon, getTheme, IButtonStyles, Icon, IContextualMenuItem, IContextualMenuItemProps, IRenderFunction, Link, mergeStyleSets, Persona, PersonaSize, ScrollablePane, ScrollbarVisibility, Stack, StackItem } from "@fluentui/react";
import { FileIconType, getFileTypeIconProps } from "@fluentui/react-file-type-icons";
import dayjs from "dayjs";
import { IStackItemStyles, IStackStyles, Label } from "office-ui-fabric-react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FileDownLoader } from "../../src/taskpane/components/helpers/fileDownloader";
import { SearchedOneDriveDirectoryBuilder } from "../../src/taskpane/components/helpers/searchedOneDriveDirectoryBuilder";
import { SearchedSharepointFoldersDirectoryBuilder } from "../../src/taskpane/components/helpers/searchedSharepointFoldersDirectoryBuilder";
import { SearchOpenExtensionHelper } from "../../src/taskpane/components/helpers/SearchOpenExtensionHelper";
import { getExtension, removeExtension } from "../../src/taskpane/components/helpers/stringHelper";
import Loader from "../../src/taskpane/components/Loader";
import { IGraphSearchSharePointResponse } from "../../src/taskpane/components/_v2/redux/api/graph/api-graph-interfaces";
import { useLazySearchSharePointQuery } from "../../src/taskpane/components/_v2/redux/api/graph/api-graph-slice";
import { RootState } from "../../src/taskpane/components/_v2/redux/storeMain";
import { WebPanel } from "../../src/taskpane/components/_v2/_shared/WebPanel/WebPanel";
import { ComponentTypes } from "../../src/taskpane/config/config";
import { displayHeight, extensions, officeFileType, SharePointFolderContentTypeIds, validPdfExtensions } from "../../src/taskpane/config/constants";
import { IDirectoryBuilder } from "../../src/taskpane/interfaces/IDirectoryBuilder";
import { IOneDriveRootDetails } from "../../src/taskpane/interfaces/IOneDriveRootDetails";
import { setContentManagerSearchValue, setIsContentManagerContentLoading } from "../../src/taskpane/redux/modules/contentManagerDirectory";
import { resetWorkingDirectories, setOneDriveDetails, setWorkingDirectories } from "../../src/taskpane/redux/modules/workingDirectory";
import { checkIfFileOrFolderExist, getFilePdfByteContent, getItem, getItemCustomSelect, getItemWebViewUrl, getListItemWebUrl, getOneDriveRootDetails, getTeamChannelRelatedSitesInfo } from "../../src/taskpane/services/GraphService";
import authModule from "../../utilities/AuthModule";
import { OpenPdfInBrowser } from "../../utilities/BrowserUtils";
import { tryDecodeUriComponent } from "../../utilities/EncodeDecode";
import { LanguageContext } from "../../utilities/LocalizationModule";
import { logger } from "../../utilities/logger";
import { CMErrorModal } from "../Panels/CMErrorModal";
import { CMFilePreviewPanel, MoveDirection, SearchSource } from "../Panels/CMFilePreviewPanel";
import "../styles/contentmanager.css";
import { CMDeleteModal } from "../Panels/CMDeleteModal";
import { brandedCommandbarIconStyles, previewWebPanelStyles } from "../../src/taskpane/config/controlStyles";
import { OneDriveUrlHelper } from "../../src/taskpane/components/helpers/oneDriveUrlHelper";
import { SearchValue } from "../../src/taskpane/redux/models/reduxModels";
import { SearchFilterBuilder } from "../../utilities/SearchFilterBuilder";
import { ModeEnum } from "../../src/taskpane/components/enums/modeEnum";
import * as microsoftTeams from '@microsoft/teams-js'
import shareToTeams from "../Services/ShareToTeamsService";
import { SharePointSiteHelper } from "../../utilities/SharePointSiteHelper";
import { ISiteInfo } from "../../src/taskpane/interfaces/ISiteInfo";
import { ITeam } from "../../src/taskpane/interfaces/services/ITeam";
import { IPageSettings } from "../../src/taskpane/interfaces/IPageSettings";
import { getFileNameDownloadTemplateAvailable, getFilenameFromTemplate } from "../../utilities/FileNameDownloadTemplateHelper";
import { ImageSizeEnum } from "../../src/taskpane/components/enums/ImageSizeEnum";
import { FolderTypeIconQuery } from "../../src/taskpane/components/helpers/folderTypeIconQuery";
import { ImageTypeEnum } from "../../src/taskpane/components/enums/ImageTypeEnum";
import { HomeItemType } from "../Home/ContentManagerHome";
import { homeBrandIconStyles, homeFontIconStyles, homeFontIconStylesMedium, iconDisplayStyle } from "../../src/taskpane/styles/iconStyles";
import { FolderTypeIconEnum } from "../../src/taskpane/components/enums/FolderTypeIconEnum";
import { CMFileSharePanel, SharePanelMode } from "../Panels/CMFileSharePanel";
import { ITeamChannelDocumentLibrary } from "../../src/taskpane/interfaces/services/ITeamChannelDocumentLibrary";
const searchIconSrc = require("../../assets/empty_search.svg");

const theme = getTheme();

const modifiedStyle: React.CSSProperties = {
    paddingBottom: 4,
};

const titleStyle: React.CSSProperties = {
    paddingBottom: 3,
    fontSize: 14
};

const linkStyle: React.CSSProperties = {
    fontSize: 16,
    color: '#026d70',
    fontWeight: 600
};

const classNames = mergeStyleSets({
    wrapper: {
        height: displayHeight,
        position: "relative",
    }
});

const headerContainerStackItemStyles: IStackItemStyles = {
    root: {
        padding: 5,
        overflowX: "auto",
        overflowY: "hidden",
        maxWidth: "calc(100vw - 400px)"
    }
};

const headerContainerCollapsedStackItemStyles: IStackItemStyles = {
    root: {
        padding: 5,
        overflowX: "auto",
        overflowY: "hidden",
        maxWidth: "calc(100vw - 85px)"
    }
};

const selectedSearchResult: React.CSSProperties = {
    backgroundColor: theme.palette.themeLighter
};

const selectedSearchResultCommandButton: IButtonStyles = {
    root: {
        backgroundColor: theme.palette.themeLighter
    }
}

const noResultsStackStyles: Partial<IStackStyles> = {
    root: { width: "100%", height: "calc(100vh - 250px)", margin: 0, padding: 0, overflow: "auto", userSelect: "none" }
};

const odataTypeProp: string = "@odata.type";
const odataSiteType: string = "#microsoft.graph.site";

const EnsureDistinctResults = (searchResultHits: any[]) => {
    return searchResultHits?.filter((obj, index, self) => index === self.findIndex((o) => o.hitId === obj.hitId));
}

interface IContentBodySPSearchResultsProps {
    searchResults?: IGraphSearchSharePointResponse,
    isFetchingResults?: boolean;
    searchValue: SearchValue;
}

interface IScrollToSelectedListItem {
    isSelected: boolean;
}

const FocusableListItem: React.FC<IScrollToSelectedListItem> = ({ isSelected, children }) => {
    const listItemRef = React.useRef<HTMLDivElement>();
    React.useEffect(() => {
        if (isSelected && listItemRef.current) {
            listItemRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [isSelected]);
    return <div ref={listItemRef}>{children}</div>;
};

export const ContentBodySPSearchResults = (props: IContentBodySPSearchResultsProps) => {
    const { searchValue } = props;

    const languageStrings = React.useContext(LanguageContext);

    const dispatch = useDispatch();

    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
    const sites = useSelector((state: RootState) => state.sharePointInfo.sites);
    const teams: ITeam[] = useSelector((state: RootState) => state.teams.teams);
    const oneDriveWebUrl = useSelector((state: RootState) => state.user.oneDriveWebUrl);
    const oneDriveRootDetails = useSelector((state: RootState) => state.workingDirectories.oneDriveRootDetails);
    const tenantOpenDocumentsInClientApp = useSelector((state: RootState) => state.tenantInfo?.openDocumentsInClientApp);
    const userAccount = useSelector((state: RootState) => state.user.account);
    const mode = useSelector((state: RootState) => state.mode.mode);
    const siteInfo = useSelector((state: RootState) => state.tenantInfo?.sites);
    const isSideMenuCollapsed = useSelector((state: RootState) => state.contentManagerDirectory.isSideMenuCollapsed);

    const [searchSharepoint, { isFetching: isFetchingSPSearchResults }] = useLazySearchSharePointQuery();

    const [fileTypeList, setFileTypeList] = React.useState<HomeItemType[]>([]);
    const [selectedFileTypeFilter, setSelectedFileTypeFilter] = React.useState<HomeItemType>();

    const [spSearchResults, setSpSearchResults] = React.useState<IGraphSearchSharePointResponse>(null);
    const [isSearchingResults, setIsSearchingResults] = React.useState<boolean>(false);
    const [selectedItem, setSelectedItem] = React.useState<any>(null);
    // const [selectedView, setSelectedView] = React.useState<string>(undefined);
    const [isCMFilePreviewPanelOpen, setIsCMFilePreviewPanelOpen] = React.useState(false);
    const [isCMErrorModalOpen, setIsCMErrorModalOpen] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [showDeleteDialog, setShowDeleteDialog] = React.useState(false);
    const [teamsContext, setTeamsContext] = React.useState(null);

    const isInOneDrive = React.useRef(false);
    React.useEffect(() => {
        if (currentDirectory) {
            isInOneDrive.current = (currentDirectory.type == ComponentTypes.OneDrive || currentDirectory.type == ComponentTypes.OneDriveSubFolder);
        }
    }, [currentDirectory?.type]);

    React.useEffect(() => {
        if (searchValue?.value?.trim().length > 0) {
            const searchFilter = searchValue?.filterType !== "" ? SearchFilterBuilder(searchValue.filterType, oneDriveWebUrl) : "";
            searchSP(searchValue.value, searchFilter);
            // setSelectedView(undefined);
        }
    }, [searchValue]);

    React.useEffect(() => {
        if (mode === ModeEnum.contentManagerTeams) {
            microsoftTeams.getContext((context) => {
                return setTeamsContext(context);
            });
        }
    }, [mode]);

    React.useEffect(() => {
        const uniqueFileTypeList: HomeItemType[] = [{
            fileType: 0
        }];

        if (Array.isArray(spSearchResults?.hits)) {
            const sites = spSearchResults.hits.filter(hit => hit.resource && hit.resource[odataTypeProp] === odataSiteType);
            if (sites && sites.length > 0) {
                uniqueFileTypeList.push({
                    fileType: 1
                });
            }

            const files = spSearchResults.hits.filter(hit => hit.resource?.listItem?.fields?.isDocument || hit.resource?.listItem?.fields?.contentTypeID?.startsWith(SharePointFolderContentTypeIds.document));
            if (files && files.length > 0) {
                uniqueFileTypeList.push({
                    fileType: 2
                });
            }

            const documentSets = spSearchResults.hits.filter(hit => hit.resource?.listItem?.fields?.isContainer && hit.resource?.listItem?.fields?.contentTypeID?.startsWith(SharePointFolderContentTypeIds.documentSet));
            if (documentSets && documentSets.length > 0) {
                uniqueFileTypeList.push({
                    fileType: 4
                });
            }

            const folders = spSearchResults.hits.filter(hit => hit.resource?.listItem?.fields?.isContainer && hit.resource?.listItem?.fields?.contentTypeID?.startsWith(SharePointFolderContentTypeIds.folder) && !hit.resource?.listItem?.fields?.contentTypeID?.startsWith(SharePointFolderContentTypeIds.documentSet));
            if (folders && folders.length > 0) {
                uniqueFileTypeList.push({
                    fileType: 3
                });
            }

            let uniqueExtensions = new Set();
            spSearchResults.hits.forEach(obj => {
                if (obj.resource?.name && obj.resource.listItem?.fields && (obj.resource.listItem.fields.isDocument || obj.resource.listItem.fields.contentTypeID?.startsWith(SharePointFolderContentTypeIds.document))) {
                    const fileExt: string = getExtension(obj.resource.name)?.toLowerCase();
                    if (fileExt) {
                        uniqueExtensions.add(fileExt);
                    }
                }
            });

            let uniqueExtensionsList: string[] = Array.from(uniqueExtensions) as string[];

            uniqueExtensionsList?.forEach(ext => {
                uniqueFileTypeList.push({
                    fileType: 0,
                    extension: ext
                })
            });
        }

        setFileTypeList(uniqueFileTypeList);

    }, [spSearchResults]);

    React.useEffect(() => {
        if (fileTypeList?.length > 0) {
            const allFilterItem = fileTypeList.find(x => !x.extension && !x.folderTypeIcon && x.fileType === 0);
            setSelectedFileTypeFilter(allFilterItem);
        }
    }, [fileTypeList]);

    const searchSP = async (searchValue: string, searchFilter: string) => {
        setIsSearchingResults(true);
        try {
            const siteUrlList: string[] = [isInOneDrive.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl];
            if (currentDirectory?.teamGroupId && currentDirectory?.teamDriveId) {
                const channelSiteInfo: ITeamChannelDocumentLibrary[] = await getTeamChannelRelatedSitesInfo(currentDirectory.teamGroupId, currentDirectory.teamDriveId);
                if (Array.isArray(channelSiteInfo) && channelSiteInfo.length > 0) {
                    channelSiteInfo.forEach(channelInfo => {
                        if (channelInfo?.sharePointSiteUrl) {
                            siteUrlList.push(channelInfo?.sharePointSiteUrl);
                        }
                    });
                }
            }

            let siteSearchResults: IGraphSearchSharePointResponse = {
                ...(await searchSharepoint({
                    siteUrlList: siteUrlList,
                    searchValue: searchValue?.trim(),
                    searchFilter: searchFilter?.trim(),
                    accessToken: await authModule.getGraphAccessToken()
                }).unwrap())
            }

            siteSearchResults.hits = EnsureDistinctResults(siteSearchResults.hits);

            setSpSearchResults(siteSearchResults);

            setIsSearchingResults(false);

            let pageLimit: number = 2;
            let from: number = 100;
            while (siteSearchResults?.moreResultsAvailable && pageLimit > 0) {
                try {
                    const moreSiteSearchResults = await searchSharepoint({
                        siteUrlList: siteUrlList,
                        searchValue: searchValue?.trim(),
                        searchFilter: searchFilter?.trim(),
                        from: from,
                        size: 100,
                        accessToken: await authModule.getGraphAccessToken()
                    }).unwrap();

                    if (moreSiteSearchResults) {
                        const resultCopy: IGraphSearchSharePointResponse = {
                            hits: [],
                            moreResultsAvailable: moreSiteSearchResults.moreResultsAvailable ?? false,
                            moreResulttotalsAvailable: moreSiteSearchResults.moreResulttotalsAvailable ?? 0
                        }
                        if (moreSiteSearchResults.hits?.length > 0) {
                            resultCopy.hits = EnsureDistinctResults(siteSearchResults.hits.concat(moreSiteSearchResults.hits));
                        }
                        else {
                            resultCopy.hits = siteSearchResults.hits;
                        }
                        siteSearchResults = resultCopy;

                        if (siteSearchResults?.moreResultsAvailable) {
                            from += 100;
                            pageLimit--;
                        }
                    }
                } catch (error) {
                    logger(error, "ContentBodySPSearchResults.tsx (searchSPSites - moreResultsAvailable)");
                    pageLimit = 0;
                }
            }

            setSpSearchResults(siteSearchResults);

        } catch (error) {
            logger(error, "ContentBodySPSearchResults.tsx (searchSPSites)");
            setErrorMessage(languageStrings.ErrorMessageGeneric);
            setIsCMErrorModalOpen(true);
        }
        setIsSearchingResults(false);
    }

    const verifyItemExists = async (hit: any) => {
        try {
            const exists = await checkIfFileOrFolderExist({ driveId: hit.resource.parentReference.driveId, id: hit.hitId });
            if (exists) {
                return true;
            }
        } catch (error) {
            // Ignore
        }
        setErrorMessage(hit?.resource?.listItem?.fields?.isDocument || hit?.resource?.listItem?.fields?.contentTypeID?.startsWith(SharePointFolderContentTypeIds.document)
            ? languageStrings.FileRecentlyDeleted
            : languageStrings.FolderRecentlyDeleted);
        setIsCMErrorModalOpen(true);
        return false;
    }

    const openFileInBrowser = async (hit: any) => {
        try {
            const extension: string = getExtension(hit.resource.name);
            if (extension?.toLowerCase() === extensions.pdf) {
                OpenPdfInBrowser((await authModule.getAccount(false)), hit.resource.parentReference.driveId, hit.hitId, hit.resource.webUrl?.startsWith(oneDriveWebUrl));
            }
            else {
                const url = await getItemWebViewUrl(await authModule.getGraphAccessToken(), hit.resource.parentReference.driveId, hit.hitId);
                window.open(url, "_blank");
            }
        } catch (error) {
            logger(error, "ContentBodySPSearchResults.tsx (openFileInBrowser)");
        }
    }

    const openFileInApp = async (hit: any, contextMenuClick: boolean = false) => {
        if (!contextMenuClick && hit?.hitId && hit.resource && hit.resource.parentReference?.driveId && !(await verifyItemExists(hit))) {
            return;
        }

        try {
            const extension: string = getExtension(hit.resource.name);
            if (!contextMenuClick && extension?.toLowerCase() === extensions.pdf) {
                OpenPdfInBrowser((await authModule.getAccount(false)), hit.resource.parentReference.driveId, hit.hitId, hit.resource.webUrl?.startsWith(oneDriveWebUrl));
            }
            else {
                const itemInfo = SearchOpenExtensionHelper.determineOfficeFileType(extension);
                if (itemInfo.type === officeFileType.App) {
                    const file = await getItemCustomSelect(await authModule.getGraphAccessToken(), hit.resource.parentReference.driveId, hit.hitId, "name,sharepointIds");
                    if (file?.sharepointIds) {
                        const fileId: string = file.sharepointIds.listItemUniqueId;
                        const fileName: string = file.name;
                        const userEmail: string = userAccount.username;
                        const userId: string = userAccount.uniqueId;
                        const siteId: string = file.sharepointIds.siteId;
                        const listId: string = file.sharepointIds.listId;
                        const webUrl: string = file.sharepointIds.siteUrl;
                        window.open(OneDriveUrlHelper.getOpenInOneDriveDesktopUrl(fileId, siteId, listId, userEmail, userId, webUrl, fileName), "_self");
                    }
                }
                else {
                    const url = await getListItemWebUrl(await authModule.getGraphAccessToken(), hit.resource.parentReference.driveId, hit.hitId);
                    window.open(`${itemInfo.localUrlPrepended}${url}`, itemInfo.localUrlPrepended ? "_self" : "_blank");
                }
            }
        } catch (error) {
            logger(error, "ContentBodySPSearchResults.tsx (openFileInApp)");
        }
    }

    const downloadFile = async (hit: any) => {
        try {
            const driveId: string = hit.resource.parentReference.driveId;
            const itemId: string = hit.hitId;
            const isOneDriveFile: boolean = oneDriveWebUrl && hit.resource.webUrl?.startsWith(oneDriveWebUrl ?? "<<undefined>>");

            let fileName: string;

            if (!isOneDriveFile && getFileNameDownloadTemplateAvailable(siteInfo)) {
                const fileItem: any = await getItem(await authModule.getGraphAccessToken(), driveId, itemId);

                if (fileItem?.sharepointIds) {
                    const fileNameFromTemplate: string = await getFilenameFromTemplate(
                        siteInfo,
                        driveId,
                        itemId,
                        fileItem.sharepointIds.siteUrl,
                        fileItem.sharepointIds.listId,
                        fileItem.sharepointIds.listItemUniqueId);

                    if (fileNameFromTemplate) {
                        fileName = fileNameFromTemplate;
                    }
                }
            }

            if (!fileName) {
                fileName = hit.resource.name;
            }

            const downloadRequestPayload = {
                accessToken: await authModule.getGraphAccessToken(),
                items: [{
                    driveId: hit.resource.parentReference.driveId,
                    itemId: hit.hitId,
                    name: fileName
                }]
            };

            await FileDownLoader.downloadFileStream(downloadRequestPayload);
        } catch (error) {
            logger(error, "ContentBodySPSearchResults.tsx (downloadFile)");
            setErrorMessage(languageStrings.DownloadFailure);
            setIsCMErrorModalOpen(true);
        }
    }

    const downloadFileAsPDF = async (hit: any) => {
        try {
            const driveId: string = hit.resource.parentReference.driveId;
            const itemId: string = hit.hitId;
            const isOneDriveFile: boolean = oneDriveWebUrl && hit.resource.webUrl?.startsWith(oneDriveWebUrl ?? "<<undefined>>");

            let [pdfContent, fileName] = await Promise.all([
                getFilePdfByteContent({
                    id: itemId,
                    driveId: driveId
                }),
                (async () => {
                    if (!isOneDriveFile && getFileNameDownloadTemplateAvailable(siteInfo)) {
                        const fileItem: any = await getItem(await authModule.getGraphAccessToken(), driveId, itemId);

                        if (fileItem?.sharepointIds) {
                            const fileNameFromTemplate: string = await getFilenameFromTemplate(
                                siteInfo,
                                driveId,
                                itemId,
                                fileItem.sharepointIds.siteUrl,
                                fileItem.sharepointIds.listId,
                                fileItem.sharepointIds.listItemUniqueId,
                                extensions.pdf
                            );

                            if (fileNameFromTemplate) {
                                return fileNameFromTemplate;
                            }
                        }
                    }
                    return null;
                })()
            ]);

            if (!fileName) {
                fileName = `${removeExtension(hit.resource.name)}.${extensions.pdf}`;
            }

            if (!pdfContent) {
                setErrorMessage(languageStrings.DownloadAsPdfFailure);
                setIsCMErrorModalOpen(true);
            }
            else {
                FileDownLoader.downloadFile(pdfContent, fileName);
            }
        } catch (error) {
            logger(error, "ContentBodySPSearchResults.tsx (downloadFileAsPDF)");
            setErrorMessage(languageStrings.DownloadAsPdfFailure);
            setIsCMErrorModalOpen(true);
        }
    }

    const [isSharePanelOpen, setIsSharePanelOpen] = React.useState(false);
    const sharePanelModeRef = React.useRef<SharePanelMode>(SharePanelMode.Share);
    const openSharePanel = React.useCallback((mode: SharePanelMode) => {
        sharePanelModeRef.current = mode;
        setIsSharePanelOpen(true);
    }, []);

    const getContextOptions = (hit: any): IContextualMenuItem[] => {
        const contextOptions: IContextualMenuItem[] = [];
        try {
            if (hit.resource) {
                const isInOneDrive: boolean = hit.resource.webUrl?.startsWith(oneDriveWebUrl);
                const isSiteResult: boolean = hit.resource[odataTypeProp] === odataSiteType;
                const extension: string = !isSiteResult ? getExtension(hit.resource.name) : "";

                if (mode === ModeEnum.contentManagerTeams
                    && hit.resource?.listItem?.fields
                    && (teamsContext?.frameContext === "task" || teamsContext?.frameContext === "content")) {
                    contextOptions.push(
                        {
                            key: "message",
                            text: languageStrings.ShareToTeams,
                            iconProps: { iconName: "TeamsLogo" },
                            onClick: () => {
                                shareToTeams(
                                    hit.resource.parentReference.driveId,
                                    hit.resource.id,
                                    hit.resource.listItem?.fields?.isDocument || hit.resource.listItem?.fields?.contentTypeID?.startsWith(SharePointFolderContentTypeIds.document),
                                    hit.resource.name,
                                    hit.resource.listItem?.fields?.contentTypeID,
                                    hit.resource.webUrl
                                );
                            }
                        },
                    )
                }

                if (isSiteResult) {
                    contextOptions.push(
                        {
                            key: "openSiteDocubird",
                            iconProps: { iconName: "FolderOpen" },
                            text: languageStrings.Open,
                            onClick: () => { openLocation(hit, true); }
                        },
                        {
                            key: "openSiteBrowser",
                            iconProps: { iconName: isInOneDrive ? "OneDriveLogo" : "SharepointLogo" },
                            text: `${languageStrings.OpenIn} ${isInOneDrive ? "OneDrive" : "SharePoint"}`,
                            onClick: () => { openLocation(hit); }
                        }
                    );
                }
                else {
                    if (hit.resource.listItem?.fields?.isDocument || hit.resource.listItem?.fields?.contentTypeID?.startsWith(SharePointFolderContentTypeIds.document)) { //File
                        const itemInfo = SearchOpenExtensionHelper.determineOfficeFileType(extension);
                        if (itemInfo?.type == officeFileType.Browser) {
                            contextOptions.push({
                                key: "openFile",
                                iconProps: { iconName: "BrowserTab" },
                                text: languageStrings.OpenFileInBrowser,
                                onClick: () => { openFileInBrowser(hit); }
                            });
                        }
                        else {
                            contextOptions.push(
                                {
                                    key: "online",
                                    text: `${languageStrings.OpenIn} ${languageStrings.Browser}`,
                                    iconProps: { iconName: "BrowserTab" },
                                    onClick: () => { openFileInBrowser(hit); },
                                    onRenderIcon: (props: IContextualMenuItemProps, defaultRender?: IRenderFunction<IContextualMenuItemProps>) => {
                                        return itemInfo && itemInfo.iconSrc ? <img src={itemInfo.iconSrc} className={brandedCommandbarIconStyles} /> : defaultRender({ ...props });
                                    },
                                },
                                {
                                    key: "app",
                                    text: `${languageStrings.OpenIn} ${languageStrings.App}`,
                                    iconProps: { iconName: "CloneToDesktop" },
                                    onClick: () => { openFileInApp(hit, true) },
                                    onRenderIcon: (props: IContextualMenuItemProps, defaultRender?: IRenderFunction<IContextualMenuItemProps>) => {
                                        return itemInfo && itemInfo.iconSrc ? <img src={itemInfo.iconSrc} className={brandedCommandbarIconStyles} /> : defaultRender({ ...props });
                                    },
                                }
                            );
                        }

                        contextOptions.push(
                            {
                                key: 'preview',
                                iconProps: { iconName: 'PreviewLink' },
                                text: languageStrings.ShowPreview,
                                onClick: () => { openPreview(hit); }
                            },
                            {
                                key: 'download',
                                iconProps: { iconName: 'Download' },
                                text: languageStrings.Download,
                                onClick: () => { downloadFile(hit); }
                            }
                        );

                        if (validPdfExtensions.some(validExt => getExtension(hit.resource.name)?.toLowerCase() === validExt)) {
                            contextOptions.push({
                                key: "downloadAsPDF",
                                text: languageStrings.DownloadAsPdf,
                                iconProps: { iconName: "PDF" },
                                onClick: () => {
                                    downloadFileAsPDF(hit);
                                }
                            });
                        }

                        contextOptions.push(
                            {
                                key: "openFileLocationDocubird",
                                iconProps: { iconName: "FolderOpen" },
                                text: languageStrings.OpenFileLocation,
                                onClick: () => { openLocation(hit, true) }
                            },
                            {
                                key: "openFileLocationBrowser",
                                text: `${languageStrings.OpenFileLocationIn} ${isInOneDrive ? "OneDrive" : "SharePoint"}`,
                                iconProps: { iconName: isInOneDrive ? "OneDriveLogo" : "SharepointLogo" },
                                onClick: () => { openLocation(hit); }
                            }
                        );
                    }
                    else { //Folder
                        contextOptions.push(
                            {
                                key: "openFolderDocubird",
                                iconProps: { iconName: "FolderOpen" },
                                text: languageStrings.OpenFolder,
                                onClick: () => { openLocation(hit, true); }
                            },
                            {
                                key: "openFolderBrowser",
                                iconProps: { iconName: isInOneDrive ? "OneDriveLogo" : "SharepointLogo" },
                                text: `${languageStrings.OpenIn} ${isInOneDrive ? "OneDrive" : "SharePoint"}`,
                                onClick: () => { openLocation(hit); }
                            }
                        );
                    }

                    // Shared options
                    if (hit.resource.id && hit.resource.parentReference) {
                        contextOptions.push(
                            {
                                key: "share",
                                iconProps: { iconName: "Share" },
                                text: `${languageStrings.Share}`,
                                onClick: () => {
                                    setSelectedItem(hit);
                                    openSharePanel(SharePanelMode.Share);
                                }
                            },
                            {
                                key: "copyLink",
                                iconProps: { iconName: "Link" },
                                text: `${languageStrings.CopyLink}`,
                                onClick: () => {
                                    setSelectedItem(hit);
                                    openSharePanel(SharePanelMode.Copy);
                                }
                            },
                            // {
                            //     key: "delete",
                            //     iconProps: { iconName: "Delete" },
                            //     text: `${languageStrings.Delete}`,
                            //     onClick: () => {
                            //         setSelectedItem(hit);
                            //         setShowDeleteDialog(true);
                            //     }
                            // }
                        );
                    }
                }
            }
        } catch (error) {
            logger(error, "ContentBodySPSearchResults.tsx (getContextOptions)");
        }
        return contextOptions;
    }

    const openPreview = (hit: any) => {
        setSelectedItem(hit);
        setIsCMFilePreviewPanelOpen(true);
    }

    const openLocation = React.useCallback(async (hit: any, openInDocubird: boolean = false) => {
        if (hit?.hitId && hit.resource && hit.resource.parentReference?.driveId && !(await verifyItemExists(hit))) {
            return;
        }

        if (hit.resource) {
            try {
                const isSiteResult: boolean = hit.resource[odataTypeProp] === odataSiteType;
                if (isSiteResult) {
                    let siteItem = {
                        id: hit.resource.id,
                        siteId: undefined,
                        name: hit.resource.displayName,
                        webUrl: hit.resource.webUrl,
                        isSite: true,
                        isHub: false,
                        hubId: undefined,
                        parentHubId: undefined
                    };

                    if (SharePointSiteHelper.hubSites?.length > 0) {
                        const hub: ISiteInfo = SharePointSiteHelper.hubSites.find(hubSite => hubSite.id === siteItem.id);
                        if (hub) {
                            siteItem.isHub = true;
                            siteItem.hubId = hub.hubId;
                            if (hub.name) siteItem.name = hub.name;
                            if (hub.parentHubId) siteItem.parentHubId = hub.parentHubId;
                        }
                    }

                    let directoryToAdd: IPageSettings = {
                        id: siteItem.id,
                        type: ComponentTypes.SharePointDocuments,
                        siteId: siteItem.id,
                        siteDisplayName: siteItem.name,
                        webUrl: siteItem.webUrl,
                        directory: "",
                        DocumentLibrary: "",
                        displayName: siteItem.name,
                        isHub: siteItem.isHub,
                        hubId: siteItem.hubId,
                        parentHubId: siteItem.parentHubId
                    };

                    const teamSite = teams?.find(team => team.siteId === siteItem.id || team.webUrl === siteItem.webUrl);
                    if (teamSite) {
                        directoryToAdd.siteId = teamSite.siteId ?? siteItem.id;
                        directoryToAdd.teamGroupId = teamSite.id;
                        directoryToAdd.teamDriveId = teamSite.driveId;
                        directoryToAdd.isSharedTeam = teamSite.isSharedTeam;
                    }

                    dispatch(setWorkingDirectories([
                        {
                            type: teamSite ? ComponentTypes.Teams : ComponentTypes.SharePoint,
                            id: "2",
                            directory: "",
                            displayName: teamSite ? ComponentTypes.Teams : ComponentTypes.SharePoint,
                            webUrl: "",
                        },
                        directoryToAdd
                    ]));
                }
                else {
                    const isFile: boolean = hit.resource.listItem?.fields?.isDocument || hit.resource.listItem?.fields?.contentTypeID?.startsWith(SharePointFolderContentTypeIds.document);
                    const driveId = hit.resource.parentReference?.driveId;
                    const locationId = isFile ? hit.resource.parentReference?.id : hit.resource.id;
                    if (!openInDocubird) {
                        const url = await getItemWebViewUrl(await authModule.getGraphAccessToken(), driveId, locationId);
                        window.open(url, "_blank");
                    }
                    else {
                        try {
                            const item = hit.resource;
                            let locationWebUrl = isFile
                                ? await getListItemWebUrl(await authModule.getGraphAccessToken(), driveId, locationId)
                                : item.webUrl;

                            if (!locationWebUrl) {
                                locationWebUrl = await getItemWebViewUrl(await authModule.getGraphAccessToken(), driveId, locationId);
                            }

                            const driveItemResult = {
                                id: locationId,
                                name: item.name,
                                driveId: driveId,
                                lastModifiedDateTime: item.lastModifiedDateTime,
                                webUrl: locationWebUrl,
                                siteId: item.parentReference?.siteId,
                                path: tryDecodeUriComponent(
                                    currentDirectory?.webUrl ? locationWebUrl?.replace(currentDirectory?.webUrl, "") : new URL(locationWebUrl)?.pathname
                                ),
                            }

                            dispatch(setIsContentManagerContentLoading(true));

                            let directoryBuilder: IDirectoryBuilder;
                            if (driveItemResult.webUrl?.startsWith(oneDriveWebUrl)) {
                                let oneDriveDetails: IOneDriveRootDetails;
                                if (!oneDriveRootDetails) {
                                    oneDriveDetails = await getOneDriveRootDetails();
                                    dispatch(setOneDriveDetails(oneDriveDetails));
                                }
                                directoryBuilder = new SearchedOneDriveDirectoryBuilder(oneDriveWebUrl, (oneDriveDetails ?? oneDriveRootDetails).sharePointListId);
                            }
                            else {
                                directoryBuilder = new SearchedSharepointFoldersDirectoryBuilder(
                                    sites,
                                    teams,
                                    currentDirectory?.type,
                                    currentDirectory?.isTeamsFolder || currentDirectory?.type === ComponentTypes.Teams
                                );
                            }

                            const directories = await directoryBuilder.getFolderDirectories(driveItemResult);
                            dispatch(setContentManagerSearchValue(""));
                            dispatch(resetWorkingDirectories(directories));
                            dispatch(setIsContentManagerContentLoading(false));
                        } catch (error) {
                            logger(error, "ContentBodySPSearchResults.tsx (openFileInBrowser - OpenInDocubird)");
                            window.open(await getItemWebViewUrl(await authModule.getGraphAccessToken(), driveId, locationId));
                        }
                    }
                }
            } catch (error) {
                logger(error, "ContentBodySPSearchResults.tsx (openLocation)");
                setErrorMessage(languageStrings.ErrorMessageGeneric);
                setIsCMErrorModalOpen(true);
            }
        }
    }, [sites, teams]);

    const getSiteRelativeURL = (hit: any) => {
        try {
            const domain = new URL(hit.resource.webUrl).origin;
            return hit.resource.webUrl.replace(domain, '');
        } catch (error) {
            logger(error, "ContentBodySPSearchResults.tsx (getSiteRelativeURL)", `Search result: ${hit?.resource?.webUrl}`);
        }
    }

    const viewResults = React.useMemo(() => {
        if (selectedFileTypeFilter === fileTypeList.find(x => !x.extension && !x.folderTypeIcon && x.fileType === 0)) {
            return spSearchResults?.hits;
        } else if (selectedFileTypeFilter === fileTypeList.find(x => !x.extension && !x.folderTypeIcon && x.fileType === 1)) {
            return spSearchResults?.hits.filter(hit => hit.resource[odataTypeProp] === odataSiteType);
        } else if (selectedFileTypeFilter === fileTypeList.find(x => !x.extension && !x.folderTypeIcon && x.fileType === 2)) {
            return spSearchResults?.hits.filter(hit => hit.resource?.listItem?.fields?.isDocument || hit.resource?.listItem?.fields?.contentTypeID?.startsWith(SharePointFolderContentTypeIds.document));
        } else if (selectedFileTypeFilter === fileTypeList.find(x => !x.extension && !x.folderTypeIcon && x.fileType === 3)) {
            return spSearchResults?.hits.filter(hit => hit.resource?.listItem?.fields?.isContainer && hit.resource?.listItem?.fields?.contentTypeID?.startsWith(SharePointFolderContentTypeIds.folder) && !hit.resource?.listItem?.fields?.contentTypeID?.startsWith(SharePointFolderContentTypeIds.documentSet));
        } else if (selectedFileTypeFilter === fileTypeList.find(x => !x.extension && !x.folderTypeIcon && x.fileType === 4)) {
            return spSearchResults?.hits.filter(hit => hit.resource?.listItem?.fields?.isContainer && hit.resource?.listItem?.fields?.contentTypeID?.startsWith(SharePointFolderContentTypeIds.documentSet));
        } else if (selectedFileTypeFilter.extension) {
            return spSearchResults?.hits.filter(hit => getExtension(hit.resource?.name)?.toLowerCase() === selectedFileTypeFilter.extension);
        }
        return null;
    }, [selectedFileTypeFilter, spSearchResults]);

    const getSelectedIndex = React.useCallback(() => {
        return (selectedItem && viewResults?.findIndex(hit => hit && hit.hitId === selectedItem.hitId)) ?? -1;
    }, [viewResults, selectedItem]);

    const move = React.useCallback((direction: MoveDirection) => {
        const currentSelectedIndex: number = getSelectedIndex();
        if (currentSelectedIndex !== -1) {
            let nextSelectedIndex: number;
            if (direction === MoveDirection.Back) {
                nextSelectedIndex = currentSelectedIndex - 1;
            }
            else {
                nextSelectedIndex = currentSelectedIndex + 1;
            }

            if (Array.isArray(viewResults) && (viewResults.length - 1) >= nextSelectedIndex) {
                try {
                    const itemToSelect = viewResults[nextSelectedIndex];
                    if (itemToSelect) {
                        setSelectedItem(itemToSelect);
                    }
                } catch (error) {
                    // ignore
                }
            }
        }
    }, [viewResults, selectedItem]);

    const onDeleteCloseSuccess = (successIds: string[], hasError: boolean) => {
        setShowDeleteDialog(false);

        if (hasError) {
            setErrorMessage(languageStrings.ErrorDeletingFiles);
            setIsCMErrorModalOpen(true);
        } else {
            const filteredHits = spSearchResults.hits.filter(hit => hit.hitId !== selectedItem.hitId);
            setSpSearchResults({
                ...spSearchResults,
                hits: filteredHits
            });
        }
    }

    const getFolderIconTypeName = (item: HomeItemType) => {
        switch (item.folderTypeIcon) {
            case FolderTypeIconEnum.sharepointFolder:
                return "Folder"

            case FolderTypeIconEnum.sharepointSite:
                return "Sites"

            case FolderTypeIconEnum.documentLibrary:
                return "Library"

            case FolderTypeIconEnum.oneDrive:
                return "One Drive"

            case FolderTypeIconEnum.oneDriveSubFolder:
                return "One Drive SubFolder"

            case FolderTypeIconEnum.teamChannel:
                return "Channels"

            case FolderTypeIconEnum.teamMainSite:
                return "Team Sites"

            case FolderTypeIconEnum.teamFolder:
                return "Team Folder"

            case FolderTypeIconEnum.sharepointDocumentSet:
                return "Document Set"

            case FolderTypeIconEnum.sharepointList:
                return "Lists"

            case FolderTypeIconEnum.sharepointHubSite:
                return "Hub Sites"

            default:
                return "";
        }
    }

    const getFontIconClassName = (fontIcon): string => {
        if (fontIcon.imageSize === ImageSizeEnum.medium) {
            return homeFontIconStylesMedium;
        }
        return homeFontIconStyles;
    }

    const getFolderIconTypeIcon = (item: HomeItemType) => {
        const folderIcon = FolderTypeIconQuery.getImage(item.folderTypeIcon);
        return folderIcon.imageType === ImageTypeEnum.fileType
            ? <Icon {...getFileTypeIconProps({ type: folderIcon.fileIconType, size: 20, imageFileType: "svg" })} styles={iconDisplayStyle} />
            : folderIcon.imageType === ImageTypeEnum.url
                ? <img src={folderIcon.location} className={homeBrandIconStyles} width={20} height={20} />
                : <FontIcon iconName={folderIcon.iconName} className={getFontIconClassName(folderIcon)} />;
    }

    const checkIsSelected = (hit: any) => {
        return hit?.hitId && selectedItem?.hitId && hit.hitId === selectedItem.hitId;
    }

    const getIsPreviewNotSupported = () => {
        if (selectedItem?.resource) {
            try {
                return (selectedItem.resource.listItem?.fields?.isContainer || selectedItem.resource[odataTypeProp] === odataSiteType) ?? false;
            } catch (error) {
                // ignore
            }
        }
        return false;
    }

    return (
        <>
            {isSearchingResults &&
                <Loader label={languageStrings.SearchingContent} />
            }
            {!isSearchingResults && !isFetchingSPSearchResults && !spSearchResults?.hits?.length &&
                <Stack verticalAlign="center" horizontalAlign="center" styles={noResultsStackStyles}>
                    <StackItem align="center">
                        <img src={searchIconSrc} />
                    </StackItem>
                    <StackItem align="center">
                        <Label disabled>{languageStrings.NoResultsFound}</Label>
                    </StackItem>
                </Stack>}
            {!isSearchingResults && spSearchResults?.hits?.length &&
                <>
                    <Stack verticalAlign="center" styles={!isSideMenuCollapsed ? headerContainerStackItemStyles : headerContainerCollapsedStackItemStyles}>
                        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 15 }}>
                            {selectedFileTypeFilter && fileTypeList && fileTypeList.length > 0 && fileTypeList.map((item, index) => {
                                return (
                                    <Stack.Item key={index}
                                        className={`home-filter-icon-container ${selectedFileTypeFilter?.extension === item?.extension && selectedFileTypeFilter?.folderTypeIcon === item?.folderTypeIcon && selectedFileTypeFilter?.fileType === item?.fileType ? "home-filter-icon-container-active" : ""}`}
                                        onClick={() => setSelectedFileTypeFilter(item)}
                                    >
                                        {item.extension && (
                                            <Stack horizontal tokens={{ childrenGap: 6 }} verticalAlign="center">
                                                <Stack.Item className="home-filter-icon-container-icon">
                                                    <Icon
                                                        {...getFileTypeIconProps({
                                                            extension: item.extension,
                                                            size: 20,
                                                            imageFileType: "svg"
                                                        })}
                                                    />
                                                </Stack.Item>
                                                <Stack.Item className="home-filter-icon-container-text">
                                                    {item.extension}
                                                </Stack.Item>
                                            </Stack>
                                        )}
                                        {item.folderTypeIcon && (
                                            <Stack horizontal tokens={{ childrenGap: 6 }} verticalAlign="center">
                                                <Stack.Item>
                                                    {getFolderIconTypeIcon(item)}
                                                </Stack.Item>
                                                <Stack.Item className="home-filter-icon-container-text">
                                                    {getFolderIconTypeName(item)}
                                                </Stack.Item>
                                            </Stack>
                                        )}
                                        {!item.folderTypeIcon && !item.extension && item.fileType === 4 && (
                                            <Stack horizontal tokens={{ childrenGap: 6 }} verticalAlign="center">
                                                <Stack.Item>
                                                    <Icon {...getFileTypeIconProps({ type: FileIconType.docset, size: 20, imageFileType: "svg" })} styles={iconDisplayStyle} />
                                                </Stack.Item>
                                                <Stack.Item className="home-filter-icon-container-text">
                                                    {"Document Sets"}
                                                </Stack.Item>
                                            </Stack>
                                        )}
                                        {!item.folderTypeIcon && !item.extension && item.fileType === 3 && (
                                            <Stack horizontal tokens={{ childrenGap: 6 }} verticalAlign="center">
                                                <Stack.Item>
                                                    {getFolderIconTypeIcon({ folderTypeIcon: 1, fileType: 0 })}
                                                </Stack.Item>
                                                <Stack.Item className="home-filter-icon-container-text">
                                                    {languageStrings.Folders}
                                                </Stack.Item>
                                            </Stack>
                                        )}
                                        {!item.folderTypeIcon && !item.extension && item.fileType === 2 && (
                                            <Stack horizontal tokens={{ childrenGap: 6 }} verticalAlign="center">
                                                <Stack.Item>
                                                    <FontIcon iconName="TextDocument" />
                                                </Stack.Item>
                                                <Stack.Item className="home-filter-icon-container-text">
                                                    {languageStrings.Files}
                                                </Stack.Item>
                                            </Stack>
                                        )}
                                        {!item.folderTypeIcon && !item.extension && item.fileType === 1 && (
                                            <Stack horizontal tokens={{ childrenGap: 6 }} verticalAlign="center">
                                                <Stack.Item>
                                                    {getFolderIconTypeIcon({ folderTypeIcon: 2, fileType: 0 })}
                                                </Stack.Item>
                                                <Stack.Item className="home-filter-icon-container-text">
                                                    {languageStrings.Sites}
                                                </Stack.Item>
                                            </Stack>
                                        )}
                                        {!item.folderTypeIcon && !item.extension && item.fileType === 0 && (
                                            <Stack.Item className="home-filter-icon-container-text-all">
                                                <div>{languageStrings.All}</div>
                                            </Stack.Item>
                                        )}
                                    </Stack.Item>
                                )
                            })}
                        </Stack>
                    </Stack>
                    <Stack horizontal>
                        <Stack.Item grow>
                            <div className={classNames.wrapper}>
                                <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                                    <div style={{ paddingRight: '50%' }}>
                                        {viewResults?.map((hit, index) => {
                                            const isSelected: boolean = checkIsSelected(hit);
                                            return (
                                                <FocusableListItem key={index} isSelected={isSelected}>
                                                    <Stack horizontal className="search-result-item" style={isSelected ? selectedSearchResult : undefined} tokens={{ childrenGap: 10 }}>
                                                        <StackItem>
                                                            {hit.resource[odataTypeProp] === odataSiteType
                                                                ? <Persona
                                                                    text={hit.resource.displayName}
                                                                    size={PersonaSize.size32}
                                                                    hidePersonaDetails={true} />
                                                                : (hit.resource?.listItem?.fields?.isDocument || hit.resource?.listItem?.fields?.contentTypeID?.startsWith(SharePointFolderContentTypeIds.document)
                                                                    ? <Icon
                                                                        {...getFileTypeIconProps({
                                                                            extension: getExtension(hit.resource.name),
                                                                            size: 32,
                                                                            imageFileType: "svg",
                                                                        })} />
                                                                    : <Icon
                                                                        {...getFileTypeIconProps({
                                                                            type: hit.resource.listItem.fields.contentTypeID?.startsWith(SharePointFolderContentTypeIds.documentSet) ? FileIconType.docset : FileIconType.folder,
                                                                            size: 32,
                                                                            imageFileType: "svg",
                                                                        })} />)}
                                                        </StackItem>
                                                        <StackItem grow>
                                                            <Stack>
                                                                <StackItem>
                                                                    <Stack horizontal>
                                                                        <StackItem grow><div style={titleStyle}><Link style={linkStyle} onClick={() => { hit.resource[odataTypeProp] === odataSiteType || hit.resource?.listItem?.fields?.isContainer ? openLocation(hit, true) : tenantOpenDocumentsInClientApp ? openFileInApp(hit) : openFileInBrowser(hit); }}>{hit.resource.displayName ?? hit.resource.name}</Link></div></StackItem>
                                                                        <StackItem>
                                                                            <CommandBarButton
                                                                                className="command-more"
                                                                                styles={isSelected ? selectedSearchResultCommandButton : undefined}
                                                                                iconProps={{ iconName: 'More' }}
                                                                                menuIconProps={{ hidden: true }}
                                                                                onMenuClick={() => {
                                                                                    if (hit?.hitId && hit.resource && hit.resource.parentReference?.driveId) {
                                                                                        verifyItemExists(hit);
                                                                                    }
                                                                                }}
                                                                                menuProps={{
                                                                                    shouldFocusOnMount: true,
                                                                                    isBeakVisible: false,
                                                                                    items: getContextOptions(hit)
                                                                                }} />
                                                                        </StackItem>
                                                                    </Stack>
                                                                </StackItem>
                                                                {hit.resource.lastModifiedBy && <div style={modifiedStyle}><span style={{ fontWeight: 600 }}>{hit.resource.lastModifiedBy.user.displayName}</span> modified on {dayjs(hit.resource.lastModifiedDateTime).format("l")}</div>}
                                                                {hit.summary && <div><span dangerouslySetInnerHTML={{ __html: hit.summary }}></span></div>}
                                                                <div className="xb-grey-text text-ellipsis" style={{ paddingTop: '5px' }}>{getSiteRelativeURL(hit)}</div>
                                                            </Stack>
                                                        </StackItem>
                                                    </Stack>
                                                </FocusableListItem>
                                            );
                                        })}
                                    </div>
                                </ScrollablePane>
                            </div>
                        </Stack.Item>
                    </Stack></>
            }
            {isCMFilePreviewPanelOpen && selectedItem && <WebPanel isOpen={isCMFilePreviewPanelOpen} width="1100px" closePanel={() => { setIsCMFilePreviewPanelOpen(false); setSelectedItem(null); }} headerText={selectedItem.resource.name} styles={previewWebPanelStyles}>
                <CMFilePreviewPanel selectedItem={selectedItem} searchSource={SearchSource.Graph} totalItemCount={viewResults?.length} selectedItemIndex={getSelectedIndex()} previewNotSupported={getIsPreviewNotSupported()} move={move} />
            </WebPanel>}
            {isCMErrorModalOpen && <CMErrorModal message={errorMessage} showDialog={isCMErrorModalOpen} closeDialog={() => setIsCMErrorModalOpen(false)} />}
            {showDeleteDialog && <CMDeleteModal showDialog={showDeleteDialog} closeDialog={() => setShowDeleteDialog(false)} selectedGraphItem={selectedItem} closeOnSuccess={onDeleteCloseSuccess} />}
            {isSharePanelOpen && selectedItem && <CMFileSharePanel panelIsOpen={isSharePanelOpen} closePanel={() => { setIsSharePanelOpen(false); setSelectedItem(null); }} items={[{ id: selectedItem.resource.id, driveId: selectedItem.resource.parentReference?.driveId, name: selectedItem.resource.name }]} hideSharingInfo={true} mode={sharePanelModeRef.current} />}
        </>
    )
};